import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default {
  __name: 'BackLink',
  props: {
  parent: { type: Object, required: true }
},
  setup(__props) {

const props = __props

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "transition-all inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 hover:transform hover:scale-105 border border-gray-300 shrink-0 shadow-sm",
    to: props.parent.link
  }, {
    default: _withCtx(() => [
      _createTextVNode(" ← " + _toDisplayString(props.parent.name), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

}